export default {
  content: [
    {
      meta: {
        id: 'I_vL9QJFhI',
        order: 0,
        component: 'CustomerHubVideo',
      },
      styles: { customClasses: '' },
      content: {
        mode: 'user',
        tagline: '',
        variant: 'variant2',
        videoUrl: '',
        posterUrl: '',
        logoHeight: '70',
        includeLogo: true,
        backgroundImageUrl:
          'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/imranidz-QXT4/home-cmp-ZsApxvKAi',
        backgroundVideoUrl: '',
      },
      componentId: 'cmp-0',
    },
    {
      meta: { component: 'Breadcrumb' },
      content: {
        link: 'home',
        text: '<p>High Level Overview / ${page.title}</p>',
      },
      componentId: 'cmp-1',
    },
    {
      meta: {
        layout: '',
        _columns: 1,
        component: 'Container',
        isFullWidth: false,
      },
      styles: { rowGap: '1rem', columnGap: '2rem' },
      content: [
        [
          {
            meta: { component: 'Title' },
            content: {
              level: '1',
              title: '${page.title}',
              pretitle: 'June 08, 2023',
              subtitle:
                '<p>Overview of how the Adobe Experience Platform manages identities, utilized our Experience Data Model (XDM) and brings together data to build a profile.</p>',
              alignment: 'center',
              textAlignment: 'center',
            },
            componentId: 'cmp-2-col_0-0',
          },
          {
            meta: {
              id: 'c3iTa6Wd4W8tOPV_ncrlM',
              layout: '',
              _columns: 1,
              component: 'Container',
              isFullWidth: false,
            },
            styles: { rowGap: '1rem', columnGap: '2rem' },
            content: [
              [
                {
                  meta: {
                    id: 'nzrOJcf7LSREuQVRRMuv0',
                    _columns: 1,
                    component: 'Container',
                    isFullWidth: false,
                  },
                  styles: {
                    gap: '2rem',
                    customClasses: 'product-info',
                  },
                  content: [
                    [
                      {
                        meta: {
                          id: 'JdGXvQT_s3Ogk95uyjeBA',
                          component: 'ProductName',
                        },
                        content: { alignment: 'left', displayAs: 1 },
                      },
                      {
                        meta: {
                          id: 'f0O6NA8zDRuIseMufaxJk',
                          component: 'ProductDescription',
                        },
                        content: { alignment: 'left' },
                      },
                    ],
                  ],
                },
                {
                  meta: { component: 'Divider' },
                  styles: { padding: '20px 0px 20px 0px' },
                  content: {
                    size: 'L',
                    length: 'M',
                    alignment: 'center',
                    orientation: 'horizontal',
                  },
                  componentId: 'cmp-1-col_0-1',
                },
                {
                  meta: {
                    id: 'tMZUo8KcjBQfMDSsHC4b_',
                    component: 'Title',
                  },
                  styles: { height: '150px' },
                  content: {
                    level: '2',
                    title: 'Session 1',
                    alignment: 'left',
                    textAlignment: 'left',
                  },
                  componentId: 'cmp-3-col_0-2',
                },
                {
                  meta: {
                    id: '5u0fHe-iGCNgclttqUWPX',
                    component: 'Text',
                  },
                  styles: { color: 'rgba(90,0,0,.9)' },
                  content: {
                    text: '<p>October 3, 2023</p>',
                    alignment: 'left',
                  },
                  componentId: 'cmp-3-col_0-3',
                },
                {
                  meta: {
                    id: '2DpkeT7GcrCLfcu_LqO8j',
                    component: 'Video',
                  },
                  styles: { height: '600px' },
                  content: {
                    url: 'https://view.adobe.com/viewer/6570ef6a757fec170d230f4f',
                    mode: 'user',
                  },
                  componentId: 'cmp-2-col_0-1-col_0-4',
                },
                {
                  meta: {
                    id: 'wBlQqiosrlr3EMoSOXu_x',
                    component: 'Iframe',
                  },
                  styles: {
                    width: '1200px',
                    height: '720px',
                    padding: '30px 0px 50px 0px',
                  },
                  content: {
                    url: 'https://view.adobe.com/viewer/656f896e8bd42cc9e3f2ccc5',
                  },
                  componentId: 'cmp-2-col_0-1-col_0-6',
                },
                {
                  meta: {
                    id: 'i0jtXH5oAZ3-2E4jbFcUb',
                    component: 'Button',
                  },
                  styles: { padding: '20px 0px 50px 0px' },
                  content: {
                    link: 'external:https://view.adobe.com/viewer/656f896e8bd42cc9e3f2ccc5',
                    label: 'Slides used in this presentation',
                    variant: 'cta',
                    alignment: 'center',
                  },
                },
              ],
            ],
          },
        ],
      ],
    },
  ],
}
